<template>
  <div class="accordion-container" @mouseout="mouseOutItem()">
    <div class="item" :class="index == active ? 'item-active':''" 
      @mouseover="mouseItem(index)" @click="toDetail(item)"
      v-for="(item, index) in data" :key="index">
      <div class="item-content" :style="{ width: (index == active ? itemWidth * 2.2 : itemWidth) + 'px' }">
        <div class="item-info" :style="{ width: itemWidth * 2.2 + 'px' }">
          <img v-lazy="item.brief" class="imagecover" />
          <div class="item-name" :style="index == active && isMouse ? 'opacity: 1':'opacity: 0'">
            <span>{{item.title}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    }
  },
  data() {
    return {
      active: 0,
      isMouse: false,
      itemWidth: 100,
      list: [
        {
          name: '品质化农业',
          image: require('@/assets/images/rr/1.jpg')
        },
        {
          name: '传承式文化',
          image: require('@/assets/images/rr/2.jpg')
        },
        {
          name: '生态化康养',
          image: require('@/assets/images/rr/3.jpg')
        },
        {
          name: '自然性研学',
          image: require('@/assets/images/rr/4.jpg')
        },
        {
          name: '专业+社交化体育',
          image: require('@/assets/images/rr/5.jpg')
        },
        {
          name: '智慧化旅游',
          image: require('@/assets/images/rr/6.jpg')
        },
        {
          name: '产业链商贸',
          image: require('@/assets/images/rr/7.jpg')
        }
      ]
    }
  },
  created() {
    
  },
  watch: {
    'data.length': {
      handler(n) {
        this.computeWidth()
      }
    }
  },
  mounted() {
    this.computeWidth()
  },
  methods: {
    computeWidth() {
      var length = this.data.length
      this.itemWidth = 1200 / (length + 1.2)
    },
    mouseItem(index) {
      this.active = index
      this.isMouse = true
    },
    mouseOutItem() {
      this.isMouse = false
    },
    toDetail(item) {
      this.$router.push({
        name: 'article',
        params: {
          ...item
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .accordion-container {
    width: 100%;
    height: 100%;
    font-size: 0;
    display: flex;
    .item {
      height: 100%;
      margin-right: 2px;
      display: inline-block;
      vertical-align: middle;
      // flex: 1;
      overflow: hidden;
      &.item-active {
        
      }
      .item-content {
        width: 100px;
        width: 100%;
        height: 100%;
        overflow: hidden;
        transition: width .8s;
      }
      .item-info {
        width: 100%;
        height: 100%;
        position: relative;
        .item-name {
          position: absolute;
          background: rgba(12, 12, 12, 0.68);
          top: 0px;
          left: 0px;
          width: 100%;
          height: 100%;
          cursor: pointer;
          opacity: 0;
          display: flex;
          transition: opacity .8s;
          span {
            color: rgb(255, 255, 255);
            font-size: 50px;
            font-family: 黑体, SimHei;
            text-align: center;
            overflow: hidden;
            margin: auto;
          }
        }
      }
    }
  }
</style>